import { Component, OnInit } from '@angular/core';
import { HotelService } from '../services/hotel.service';
import { MessageService } from '../services/message.service';

@Component({
  selector: 'app-units',
  templateUrl: './units.component.html',
  styleUrls: ['./units.component.css']
})
export class UnitsComponent implements OnInit {

  constructor(private hotelService: HotelService, private messageService: MessageService) { }

  ngOnInit() {
    this.getUnits();
  }

  obj: any;unit_name;
  addUnit(){
    this.obj = { "unit_name": this.unit_name };
    this.hotelService
      .addUnit(this.obj)
      .subscribe(response => {
        // console.log(response);
        this.getUnits();
        this.unit_name = null;
      })
  }

  units: any;
  getUnits(){
    this.hotelService
      .getUnits({})
      .subscribe(profiles => {
        this.units = profiles;
        // console.log(this.profiles);
      })
  }

  editRowId: any;

  toggle(id){
    this.editRowId = id;
  }

  updateUnit(a,b){
    // console.log(a,b);
    this.hotelService
      .updateUnit({"id":a,"unit_name":b})
      .subscribe(res => {
        this.getUnits();
        this.editRowId = '';
      })
  }

  deleteUnit(a){
    this.hotelService
      .deleteUnit({"id":a})
      .subscribe(res => {
        this.getUnits();
        this.editRowId = '';
      })
  }
}



// WEBPACK FOOTER //
// D:/xampp/htdocs/tejashree/src/app/units/units.component.ts